import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLink } from "uitk-react-link";
import { UitkIcon } from "uitk-react-icons";
import { UitkCardTextSegment, UitkCardSectionSeparatorType } from "uitk-react-cards";

import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { TravelGuideLinkProps } from "../typings";
import { Geo } from "typings/flexFramework/FlexDefinitions";

enum GeoType {
  MULTI_CITY = "multi_city_vicinity",
  CITY = "city"
}

enum TravelGuideLinkType {
  SPOKE_PAGE = "spokePage",
  NEIGHBORHOOD_PAGE = "neighborhoodPage"
}

const TravelGuideLink = (props: TravelGuideLinkProps) => {
  const { model, context } = props;
  const { travelGuideLink } = model;

  if (!travelGuideLink) {
    return null;
  }

  const getLocationBasedOnPageType = (): Geo | null => {
    const { location: baseLocation } = context.searchContext;

    if (travelGuideLink === TravelGuideLinkType.SPOKE_PAGE) {
      return baseLocation;
    }

    const { parent: parentLocation } = baseLocation;
    const parentLocationType = parentLocation?.realWorldGeo?.type;

    const isCityType = parentLocationType === GeoType.CITY || parentLocationType === GeoType.MULTI_CITY;

    if (!isCityType) {
      return null;
    }

    return parentLocation;
  };

  const locationToLinkTo = getLocationBasedOnPageType();

  if (!locationToLinkTo) {
    return null;
  }

  const { id, defaultName, localizedName } = locationToLinkTo;
  if (!(id && defaultName && localizedName)) {
    return null;
  }

  const locationHref = `/${defaultName.replace(/ /g, "-").replace(/[^a-zA-Z0-9-_]/g, "")}.dx${id}`;

  const { formatText } = useLocalization();

  return (
    <UitkCardTextSegment separator={UitkCardSectionSeparatorType.TOP}>
      <UitkLink>
        <TrackedLink
          moduleName="TG.LP.Dest.Jumplinks"
          rfrr="city.travel.guide.link"
          href={locationHref}
          linkName="RFRR Action Link"
        >
          <UitkIcon name="arrow_back" />
          <span>{formatText("jumplinks.cityTravelGuideLink", localizedName)}</span>
        </TrackedLink>
      </UitkLink>
    </UitkCardTextSegment>
  );
};

export default TravelGuideLink;
